import Toast from './Toast';
import ToastManager from './ToastManager';

export { ToastManager };
export default Toast;
